<div class="layout-content">
<form (ngSubmit)="submit()" [formGroup]="addTechnicianForm">
	<!-- ROW * -->
	<div class="grid">
		<div class="col-12">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.technicianCode, 'borderRow')">
				 <div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.technicianCode, 'label')">{{ 'INSERT_TECHNICIAN_CODE' | translate }}</div>
				 <div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.technicianCode, 'borderInput')">
						<input type="text" pInputText 
							 [ngClass]="dynamicInputTextWidth()"
							 id="support-input-technicianCode"
							 formControlName="technicianCode"
							 placeholder="{{ 'INSERT_TECHNICIAN_CODE' | translate }}"
							 maxlength="8"
						/>
				 </div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.f.technicianCode)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'INVALID_CODE' | translate }}</small>
		</div>
	</div>
	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="button" pButton pRipple (click)="findTechnician();"
			 label="{{ 'FIND_BY_CODE' | translate }}"
			 class="p-button-primary text-xl font-normal"
			 [ngClass]="dynamicButtonWidth()"
			 >
		</button>
	</div>
	<div class="flex justify-content-center align-items-center">
		<div class="grid col-12 mt-5 mb-1 card border-round-xl bg-green-200"
			*ngIf="technician && !technician.AssignedTechnician">
			<div class="col-12 flex align-items-center justify-content-center text-green-700">
				<i class="pi cm-check-circle text-2xl pr-2"></i>
				<span>{{ 'ASSIGN_TECHNICIAN_SUCCESS' | translate }}</span>
			</div>
			<div class="col-12 text-green-700 text-center">
				<span>{{ technician.FirstName }} {{ technician.LastName }}</span>
			</div>
			<div class="col-12 text-green-700 text-center">
				<span>{{ technician.Email }}</span>
			</div>
		</div>
		<div class="grid col-12 mt-5 mb-1 card border-round-xl bg-yellow-200"
			*ngIf="technician && technician.AssignedTechnician">
			<div class="col-12 flex align-items-center justify-content-center text-yellow-700">
				<i class="pi cm-alert text-2xl pr-2"></i>
				<span>{{ 'ALREADY_ASSOCIATED' | translate }}</span>
			</div>
			<div class="col-12 text-yellow-700 text-center">
				<span>{{ technician.FirstName }} {{ technician.LastName }}</span>
			</div>
			<div class="col-12 text-yellow-700 text-center">
				<span>{{ technician.Email }}</span>
			</div>
		</div>
		<div class="grid col-12 mt-5 mb-1 card border-round-xl bg-red-300"
			*ngIf="!technician && searchFailed">
			<div class="col-12 flex align-items-center justify-content-center text-red-700">
				<i class="pi cm-alert text-2xl pr-2"></i>
				<span>{{ 'TECH_CODE_NOT_FOUND' | translate }}</span>
			</div>
		</div>
	</div>
	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="submit" pButton pRipple
			[disabled]="!technician || technician.AssignedTechnician" label="{{ 'CONFIRM' | translate }}"
			class="p-button-success text-xl font-normal mb-2 mx-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
		<button type="button" pButton pRipple (click)="closeDialog()"
			label="{{ 'CANCEL' | translate }}"
			class="p-button-secondary text-xl font-normal mb-2 mx-1"
			[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
</form>
</div>
